import React, { useState, useEffect } from 'react'
import Loading from '../general/Loading';
import { MdPersonSearch } from 'react-icons/md';
import { MdOutlineGroups } from "react-icons/md";
import { MdOutlineListAlt } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const ViewUsers = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedChannel, setSelectedChannel] = useState('');
  const [review, setReview] = useState(false);
  const [refList, setRefList] = useState([]);
  const [planList, setPlanList] = useState([]);


  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.tradeintell.com/get-users');

        if (response.ok) {
          const data = await response.json();

          setUsers(data);
          setLoading(false);
        } else {
          setLoading(false);
          console.error('Failed to fetch users');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };

    fetchUsers();
  }, []);



  const fetchReffList = async (userID) => {
    setLoading(true);

    try {
      const response = await fetch(
        `https://api.tradeintell.com/get-refer-history/${userID}`
      );

      if (response.ok) {
        const data = await response.json();

        const sortedData = data.sort(
          (a, b) => new Date(b.ref_on) - new Date(a.ref_on)
        );

        setRefList(sortedData);
      } else {
        console.error("Failed to fetch referral list");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    setLoading(false);
  };

  

  const filterUsers = users.filter(myItem =>
  (myItem.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    myItem.mobile?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    myItem.user_id?.toLowerCase().includes(searchQuery.toLowerCase()))
  );


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <>
      <section className='my-4'>
        <div className='px-4'>

          <p className='page-heading'>View Users</p>
          <p className='para-text text-muted'>Here you can see a list of all registered users in the app.
          </p>
          <div className='d-flex'>
            <MdPersonSearch size={30} className='align-content-center' />
            <input
              type="text"
              className="contact-control py-2"
              placeholder="Search By Name, Mobile, User Id"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>


          <div className='table-responsive mt-3'>
            <table className='w-100 table'>

              <thead>
                <tr>
                  <th>S No</th>
                  <th>Reg On</th>
                  <th>User Id</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  {/* <th>Country</th> */}
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {filterUsers.length > 0 ? (
                  filterUsers.map((user, index) => (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>{formatDate(user.created_on)}</td>
                      <td>{user.user_id}</td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.mobile}</td>
                      {/* <td>{user.country || '-'}</td> */}
                      <td>



                        <MdOutlineGroups
                          size={20}
                          title="View Referral List"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedChannel(user);
                            setReview(true);
                            fetchReffList(user.user_id);
                          }}
                          className='me-2'
                        />

                       <MdOutlineListAlt
    size={20}
    title="Plans Purchased"
    style={{ cursor: "pointer" }}

     onClick={() => {
        navigate("/user-plan-history", {
            state: {
                userId: user.id,
                userName: user.name,
            },
        });
    }}
/>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>


            </table>
          </div>


        </div>
      </section>



      {loading && <Loading setLoading={setLoading} />}



      {review && (
        <>
          <section className='detail-dialog p-2' onClick={() => setReview(false)}>
            <div className='detail-dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>

       <button className='float-end btn btn-outline-warning' onClick={() => setReview(false)}>Close</button>
                 
    <p className="sidebar-menu-title text-dark fs-6 my-0">
        Referral List of {" "}
           <span className="text-primary fw-semibold">
     {selectedChannel.name}
           </span>
   
    </p>
          <p className='para-text text-muted'>Find the referral history below.</p>




              <div className="table-responsive">
                {loading ? (
                  <p className="text-center">Loading...</p>
                ) : (
<table className='table w-100 border channel-table fw-semibold para-text'>
                    <thead className='table-light'>
                      <tr>
                        <th>SN</th>
                        <th>Name</th>
                        <th>Referral ID</th>
                        <th> Date</th>
                     
                     
                      </tr>
                    </thead>

                    <tbody>
                      {refList.length > 0 ? (
                        refList.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.ref_to_name}</td>
                            <td>{item.ref_to_id}</td>
                            <td>{formatDate(item.ref_on)}</td>
                         
                       
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Referral Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>


            </div>
          </section>

        </>
      )}




    </>
  )
}

export default ViewUsers